import styled from 'styled-components'
import Image from 'next/legacy/image'
import { P } from 'common/typography'
import { LinearProgress } from '@material-ui/core'

const NoReposStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 40vh;
  p {
    margin-top: 8px;
  }
  @media(min-width: 768px) {
    height: 238px;
  }
`

const RepositoriesListStyled = styled.div`
  min-height: 40vh;
  .label-container {
    overflow: auto;
    border: 1px solid var(--neutral60);
    max-height: 40vh;
  }
  @media(min-width: 768px) {
    min-height: 238px;
    .label-container {
      max-height: 238px;
    }
  }
`

const LabelStyled = styled.label`
  cursor: pointer;
  background: var(--white);
  color: var(--neutral100);
  display: block;
  padding: 10px 8px;
  font-size: 16px;
  line-height: 24px;
  transition: 200ms ease-in-out background;
  &:hover {
    background: var(--neutral20);
  }
  &:active {
    background: var(--neutral20);
  }
  input {
    display: none;
  }
`

function RepoItem({ repo, setSelected }) {
  return (
    <LabelStyled htmlFor={`repo-${repo.name}`}>
      {repo.name}
      <input
        name="repository"
        id={`repo-${repo.name}`}
        type="radio"
        s
        value={repo.name}
        onChange={() => setSelected(repo)}
      />
    </LabelStyled>
  )
}

function RepoList({
  projectFiltered, repos, setSelected, searchLoading,
}) {
  if (repos && repos.length === 0 && projectFiltered.length === 0) {
    return (
      <NoReposStyled>
        <Image src="/images/profile/no-repos.png" alt="Icono de un repositorio" width="42.67" height="55.95" />
        <P align="center" fontSize="20" lineHeight="32" fontWeight="700" color="var(--neutral60)">Ningun repositorio encontrado</P>
      </NoReposStyled>
    )
  }

  if (searchLoading) {
    return (
      <LinearProgress color="secondary" />
    )
  }

  return (
    <RepositoriesListStyled>
      <div className="label-container">
        {projectFiltered?.length !== 0 ? projectFiltered.map((repo) => (
          <RepoItem repo={repo} setSelected={setSelected} />
        )) : repos?.map((repo) => (
          <RepoItem repo={repo} setSelected={setSelected} />
        ))}
      </div>
    </RepositoriesListStyled>
  )
}

export default RepoList
